export default {
  methods: {
    open() {
      this.$refs.modal.open()
    },
    async close() {
      await this.$refs.modal.close()
    }
  }
}
